import { Component, Output, EventEmitter } from '@angular/core';
import { trigger, transition, keyframes, animate, style } from '@angular/animations';
import { ComponentBase } from 't4core';

@Component({
  selector: 'app-dancing-envelope',
  templateUrl: './dancing-envelope.component.html',
  styleUrls: ['./dancing-envelope.component.css'],
  animations: [
    trigger('pulse', [
      transition('* <=> *', [
        animate(
          '1.2s ease-in-out',
          keyframes([
            style({ transform: 'scale(1)', offset: 0 }),      
            style({ transform: 'scale(1.1)', offset: 0.25 }),    
            style({ transform: 'scale(0.9)', offset: 0.5 }),
            style({ transform: 'scale(1.1)', offset: 0.75 }),  
            style({ transform: 'scale(1)', offset: 1 }) 
          ])
        )
      ])
    ])
  ],
  standalone: false
})
export class DancingEnvelopeComponent extends ComponentBase {
  danceState = true;
  isWhite = true;
  @Output() public action = new EventEmitter<string>();

  constructor() {
    super();
  }

  restartAnimation() {
    this.danceState = !this.danceState;
    this.isWhite = !this.isWhite;
  }

  openOffer() {
    this.action.emit("InviteFriends");
  }
}
